import SearchInputGroup from './SearchInputGroup';

export default SearchInputGroup;



// WEBPACK FOOTER //
// ./src/components/SolicitationsSearchBar/subComponents/SearchInputGroup/index.jsx